var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreenTickBuilder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.87076 21C4.33481 21 3.87585 20.8043 3.49387 20.413C3.11254 20.021 2.92188 19.55 2.92188 19V5C2.92188 4.45 3.11254 3.979 3.49387 3.587C3.87585 3.19567 4.33481 3 4.87076 3H18.5129C19.0489 3 19.5078 3.19567 19.8898 3.587C20.2711 3.979 20.4618 4.45 20.4618 5V19C20.4618 19.55 20.2711 20.021 19.8898 20.413C19.5078 20.8043 19.0489 21 18.5129 21H4.87076ZM10.3276 15.775C10.4576 15.775 10.5794 15.7543 10.693 15.713C10.8067 15.671 10.9123 15.6 11.0097 15.5L16.5397 9.825C16.7183 9.64167 16.8077 9.41667 16.8077 9.15C16.8077 8.88333 16.7102 8.65 16.5153 8.45C16.3367 8.26667 16.1093 8.175 15.8332 8.175C15.5571 8.175 15.3298 8.26667 15.1511 8.45L10.3276 13.4L8.20822 11.225C8.02957 11.0417 7.81032 10.95 7.55047 10.95C7.29062 10.95 7.06325 11.05 6.86836 11.25C6.68971 11.4333 6.60039 11.6667 6.60039 11.95C6.60039 12.2333 6.68971 12.4667 6.86836 12.65L9.64552 15.5C9.74296 15.6 9.84853 15.671 9.96221 15.713C10.0759 15.7543 10.1977 15.775 10.3276 15.775Z",
    fill: "#18EB04"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickBuilder);
export default __webpack_public_path__ + "static/media/green-tick-builder.f905f769118d3d28277b83486d4e65bd.svg";
export { ForwardRef as ReactComponent };